export const RESERVATION_ROOT = "/reservation";
export const PUBLIC_ADS = "/ads/public/get";
export const ADS_ROOT = "/ads";